module.exports = ".content-wrapper {\n  position: relative; }\n"